import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptPost } from '../services/moderation';
import { moderationQueryKeys } from './query-keys';

export const useAcceptPostMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (postId) => {
      const result = await acceptPost(postId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to accept post');
      }
      return result.data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: moderationQueryKeys.queue() });
      if (options.onSuccess) {
        options.onSuccess(...args);
      }
    },
    ...options,
  });
};
